import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="select"
export default class extends Controller {
  connect() {}

  isOptionSelected(event) {
    const selected = this.element.selectedOptions;
    if (selected.length == 1 && selected[0].value == event.params['option']) {
      this.dispatch('selected');
    } else {
      this.dispatch('not-selected');
    }
  }
}
